import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Input,
    InputGroup,
    InputGroupText,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    Label,
    FormGroup,
    Badge,
    Spinner,
    Pagination,
    PaginationItem,
    PaginationLink,
    Alert
} from "reactstrap";
import { useAuth } from "../../Provider/AuthProvider";
import StockCorrectionModal from "./StockCorrectionModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
interface OrderLine {
    id: string;
    rowid: string;
    ref: string;
    label: string;
    qty: number;
    qty_received: number;
    qty_reception: number;
    price: number;
    remise_percent: number;
    tva_tx: number;
    subprice: number;
    total_ht: number;
    total_ttc: number;
    fk_product: string;
    fk_product_fournisseur_price?: string;
    batch?: string;
    barcode?: string;
    stock?: number;
    brand_name?: string;
    description?: string;
    customer_order_ref?: string;
    customer_order_id?: string;
}

interface FournisseurOrder {
    rowid: string;
    ref: string;
    ref_supplier: string;
    date_creation: string;
    date_commande: string | null;
    name: string;
    fk_statut: string;
    date_livraison: string | null;
    firstname: string;
    lastname: string;
    total_ht: string;
    total_tva: string;
    total_ttc: string;
    billed: string;
    lines?: OrderLine[];
}

interface FournisseurOrdersResponse {
    success: boolean;
    message: string;
    data: FournisseurOrder[];
    nbtotalofrecords: number;
    totalpages: number;
    count: number;
}

interface Fournisseur {
    id: string;
    nom: string;
    code_fournisseur: string;
}

interface Entrepot {
    id: string;
    ref: string;
}

interface FournisseursDataResponse {
    success: boolean;
    message: string;
    data: any[];
    fournisseurs: Fournisseur[];
    entrepots: Entrepot[];
    entity: number;
    entityname: string;
}

interface AchatPrice {
    fourn_qty: string;
    fourn_unitprice: string;
    fourn_remise_percent: string;
    fourn_name: string;
    fourn_ref?: string;
    error?: string;
}

interface Product {
    id: string;
    ref: string;
    brand_id: string;
    brand_name: string;
    label: string;
    stock: number;
    barcode: string;
    fournisseur?: string;
    achat_prices: AchatPrice;
}

interface ProductSearchResponse {
    success: boolean;
    message: string;
    data: Product[];
    term: string;
    entity: number;
    entityname: string;
}

interface ReceptionLine {
    id: string;
    fk_product: string;
    fk_commandefournisseur: string;
    fk_commandefournisseurdet: string;
    fk_product_fournisseur_price?: string;
    qty_ordered: number;
    qty_received: number;
    qty_new: number;
    stock_reception: number;
    pu_ht: number;
    remise_percent: number;
    tva_tx: number;
    label: string;
    ref: string;
    barcode?: string;
    batch?: string;
    stock?: number;
    brand_name?: string;
    description?: string;
    customer_order_ref?: string;
    customer_order_id?: string;
}
interface ReceptionSuccess {
    type: 'simple' | 'withNavigation';
    message: string;
    commande_ref?: string;
    commande_id?: number;
    entityname?: string;
}
interface CreateReceptionResponse {
    success: boolean;
    message: string;
    reception_id?: string;
    data?: any;
}

const Stock = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [receptionModalOpen, setReceptionModalOpen] = useState(false);
    const [articlesModalOpen, setArticlesModalOpen] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState("");
    const [selectedSupplierId, setSelectedSupplierId] = useState("");
    const [orderNumber, setOrderNumber] = useState("");
    const [entrepot, setEntrepot] = useState("");
    const [productSearch, setProductSearch] = useState("");
    const [productLines, setProductLines] = useState<ReceptionLine[]>([]);
    // New states for API data
    const [ordersToReceive, setOrdersToReceive] = useState<FournisseurOrder[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [countPerPage, setCountPerPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    // States for fournisseurs data
    const [fournisseurs, setFournisseurs] = useState<Fournisseur[]>([]);
    const [entrepots, setEntrepots] = useState<Entrepot[]>([]);
    const [loadingFournisseurs, setLoadingFournisseurs] = useState(false);
    const [fournisseursError, setFournisseursError] = useState<string | null>(null);
    // States for product search
    const [searchingProducts, setSearchingProducts] = useState(false);
    const [searchResults, setSearchResults] = useState<Product[]>([]);
    const [searchError, setSearchError] = useState<string | null>(null);
    const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
    // New states for reception
    const [selectedOrder, setSelectedOrder] = useState<FournisseurOrder | null>(null);
    const [orderLines, setOrderLines] = useState<OrderLine[]>([]);
    const [receptionLines, setReceptionLines] = useState<ReceptionLine[]>([]);
    const [receptionMode, setReceptionMode] = useState<'new' | 'existing'>('new');
    const [selectedOrderId, setSelectedOrderId] = useState<string>('');
    const [creatingReception, setCreatingReception] = useState(false);

    const [receptionSuccess, setReceptionSuccess] = useState<ReceptionSuccess | null>(null);
    const [receptionError, setReceptionError] = useState<string | null>(null);
    const [stockCorrectionModalOpen, setStockCorrectionModalOpen] = useState(false);
    const [shippingExpedition, setShippingExpedition] = useState(false);
    const [shipResult, setShipResult] = useState<{ success: boolean; message: string } | null>(null);
    const [shipDeclined, setShipDeclined] = useState(false);
    // Fetch orders from API


    // Add these new state variables near your other search states
    const [searchProductRef, setSearchProductRef] = useState("");
    const [searchFournisseur, setSearchFournisseur] = useState("");
    const [searchStatus, setSearchStatus] = useState("0,1,2,3,4");

    const fetchFournisseurOrders = async (resetPage = true) => {
       // debugger;
        try {
            setOrdersToReceive([]);
            setLoading(true);
            setError(null);

            // Reset to page 1 when performing a new search
            if (resetPage) {
                setPage(1);
            }

            // Find the selected fournisseur object
            const selectedFournisseurObj = fournisseurs.find(f => f.id === searchFournisseur);

            const statusArray =
                searchStatus.trim() === ""
                    ? [] // ou null selon ce que ton API attend
                    : searchStatus.split(",").map(s => s.trim());

            const data = {
                action: "ordersfournisseurs",
                entity: user.entity,
                search_status: statusArray,
                search_product_ref: searchProductRef.trim(),
                search_four: selectedFournisseurObj?.id,
                page: page  ,
                limit: 100,
            }
            console.log(data, "data");
            const response: any = await axios.post<FournisseurOrdersResponse>(
                "https://api.apapiecesauto.fr/apiV2/",
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`
                    }
                }
            );

            const responseData = response;
            if (responseData.success) {
                setOrdersToReceive(responseData.data || []);
                console.log(responseData.data, "fff")
                setTotalCount(responseData.nbtotalofrecords || 0);
                setTotalPages(responseData.totalpages || 1);
                setCountPerPage(responseData.count || 0);
            } else {
                setOrdersToReceive([]);
                setTotalCount(0);
                setTotalPages(1);
                setCountPerPage(0);
            }
        } catch (err: any) {
            setError(err.message || "Une erreur est survenue");
            console.error("Error fetching fournisseur orders:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSelectFournisseur = (e: React.ChangeEvent<HTMLInputElement>) => {
        const fournisseurId = e.target.value;
        const fournisseur = fournisseurs.find(f => f.id === fournisseurId);
        if (fournisseur) {
            setSelectedSupplier(fournisseur.nom);
            setSelectedSupplierId(fournisseur.id);
        } else {
            setSelectedSupplier("");
            setSelectedSupplierId("");
        }
    };

    // Fetch fournisseurs and entrepots data
    const fetchFournisseursData = async () => {
        try {
            setLoadingFournisseurs(true);
            setFournisseursError(null);

            const response: any = await axios.post<FournisseursDataResponse>(
                "https://api.apapiecesauto.fr/apiV2/",
                {
                    action: "getDataFournisseurs",
                    entity: user.entity
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`
                    }
                }
            );

            const responseData = response;

            if (responseData.success) {
                setFournisseurs(responseData.fournisseurs || []);
                setEntrepots(responseData.entrepots || []);
                // Set default entrepot if available
                if (responseData.entrepots && responseData.entrepots.length > 0) {
                    setEntrepot(responseData.entrepots[0].ref);
                }
            } else {
                throw new Error(responseData.message || "Failed to fetch fournisseurs data");
            }
        } catch (err: any) {
            setFournisseursError(err.message || "Erreur lors du chargement des fournisseurs");
            console.error("Error fetching fournisseurs data:", err);
        } finally {
            setLoadingFournisseurs(false);
        }
    };

    // Search products API with fournisseur
    const searchProducts = async (term: string) => {
        if (term.length < 3) {
            setSearchResults([]);
            return;
        }

        try {
            setSearchingProducts(true);
            setSearchError(null);

            const response: any = await axios.post<ProductSearchResponse>(
                "https://api.apapiecesauto.fr/apiV2/",
                {
                    action: "erpref",
                    term: term,
                    entity: user.entity,
                    fournisseur: selectedSupplierId || undefined
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`
                    }
                }
            );

            const responseData = response;
            if (responseData.success) {
                setSearchResults(responseData.data || []);
            } else {
                throw new Error(responseData.message || "Failed to search products");
            }
        } catch (err: any) {
            setSearchError(err.message || "Erreur lors de la recherche de produits");
            console.error("Error searching products:", err);
        } finally {
            setSearchingProducts(false);
        }
    };

    // Handle product search with debounce
    const handleProductSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setProductSearch(value);

        // Clear previous timeout
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Set new timeout for debounce
        if (value.length >= 3) {
            const timeout = setTimeout(() => {
                searchProducts(value);
            }, 500);
            setSearchTimeout(timeout);
        } else {
            setSearchResults([]);
        }
    };

    useEffect(() => {
        if (user) {
            // Use a debounce or only fetch when searchTerm is set
            fetchFournisseurOrders(false); // Don't reset page on useEffect trigger
            fetchFournisseursData();
        }
    }, [page, user]);

    // Helper function to convert status code to text
    const getStatusText = (statusCode: string) => {
        switch (statusCode) {
            case "0": return "En attente";
            case "1": return "Validée";
            case "2": return "Approuvée";
            case "3": return "Commandée/En cours";
            case "4": return "Reçue partiellement";
            case "5": return "Reçue totalement";
            case "6": return "Annulée";
            case "7": return "Annulée (jamais reçue)";
            case "9": return "Refusée";
            default: return `Statut: ${statusCode}`;
        }
    };

    // Helper function to get status color
    const getStatusColor = (statusCode: string) => {
        switch (statusCode) {
            case "0": return "secondary";
            case "1": return "info";
            case "2": return "primary";
            case "3": return "warning";
            case "4": return "success";
            case "5": return "success";
            case "6": return "danger";
            case "7": return "danger";
            case "9": return "dark";
            default: return "light";
        }
    };

    // Helper function to format date
    const formatDate = (dateString: string | null) => {
        if (!dateString) return "N/A";
        try {
            const date = new Date(dateString);
            return date.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (e) {
            return dateString;
        }
    };

    // Helper function to get price data from achat_prices
    const getPriceData = (product: Product) => {
        const achatPrice = product.achat_prices;
        return {
            fourn_qty: parseFloat(achatPrice.fourn_qty) || 1,
            fourn_unitprice: parseFloat(achatPrice.fourn_unitprice) || 0,
            fourn_remise_percent: parseFloat(achatPrice.fourn_remise_percent) || 0,
            fourn_name: achatPrice.fourn_name || ""
        };
    };

    const handleContinue = () => {
        // Reset reception mode to new
        setReceptionMode('new');
        setReceptionLines([]);
        setProductLines([]);
        setSelectedOrder(null);
        setSelectedOrderId('');
        setReceptionModalOpen(false);
        setArticlesModalOpen(true);
    };

    // Function to handle receiving an existing order
    const handleReceiveExistingOrder = async (order: FournisseurOrder) => {
        try {

            // Use the lines already provided in ordersfournisseurs response
            const orderLines = order.lines || [];


            // Map lines to reception format for the new API
            const receptionLinesData = orderLines.map((line: any) => ({
                id: `${line.rowid}-${Date.now()}`,
                fk_product: line.fk_product,
                fk_commandefournisseur: order.rowid,
                fk_commandefournisseurdet: line.rowid, // This is the line_id for existing order
                qty_ordered: parseFloat(line.qty) || 0,
                qty_received: parseFloat(line.qty_received) || 0,
                qty_new: (parseFloat(line.qty) || 0) - (parseFloat(line.qty_received) || 0), // Calculate remaining quantity
                stock_reception: 0,
                pu_ht: parseFloat(line.subprice) || 0,
                remise_percent: parseFloat(line.remise_percent) || 0,
                tva_tx: parseFloat(line.tva_tx) || 20,
                label: line.label || "Produit inconnu",
                ref: line.ref || "N/A",
                barcode: line.barcode || "",
                stock: line.stock || 0,
                brand_name: line.brand_name || "",
                description: line.description || line.label || "",
                customer_order_ref: line.customer_order_ref || "",
                customer_order_id: line.customer_order_id || "",
            }));

            setReceptionLines(receptionLinesData);
            setProductLines(receptionLinesData);
            setReceptionMode('existing');
            setSelectedSupplier(order.name || "");
            setOrderNumber(order.ref_supplier || order.ref || "");

            // We need to find the actual supplier ID from fournisseurs array
            const supplier = fournisseurs.find(f => f.nom === order.name);
            setSelectedSupplierId(supplier?.id || "");

            setSelectedOrderId(order.rowid);
            setSelectedOrder(order);
            setArticlesModalOpen(true);
        } catch (err: any) {
            console.error("Error preparing reception:", err);
            setError("Impossible de préparer la réception de cette commande");
        } finally {
            setLoading(false);
        }
    };

    // Add product line for new reception
    const addProductLine = (product?: Product) => {
        let priceData;
        if (product) {
            priceData = getPriceData(product);
        } else {
            priceData = {
                fourn_qty: 1,
                fourn_unitprice: 0,
                fourn_remise_percent: 0,
                fourn_name: ""
            };
        }

        const newLine: ReceptionLine = {
            id: Date.now().toString(),
            fk_product: product ? product.id : "",
            fk_commandefournisseur: receptionMode === 'existing' ? selectedOrderId : "",
            fk_commandefournisseurdet: "", // Empty for new reception
            qty_ordered: priceData.fourn_qty,
            qty_received: 0,
            qty_new: priceData.fourn_qty,
            stock_reception: product ? product.stock : 0,
            pu_ht: priceData.fourn_unitprice,
            remise_percent: priceData.fourn_remise_percent,
            tva_tx: 20,
            label: product ? product.label : "",
            ref: product ? product.ref : "",
            barcode: product ? product.barcode : "",
            stock: product ? product.stock : 0,
            brand_name: product ? product.brand_name : "",
            description: product ? product.label : "",
            fk_product_fournisseur_price: product ? product.id : undefined
        };

        setProductLines([...productLines, newLine]);
        setProductSearch("");
        setSearchResults([]);
    };

    // Remove product line
    const removeProductLine = (id: string) => {
        setProductLines(productLines.filter(line => line.id !== id));
    };

    // Update product line
    const updateProductLine = (id: string, field: string, value: any) => {
        setProductLines(productLines.map(line => {
            if (line.id === id) {
                const updatedLine = { ...line, [field]: value };
                // If updating qty_new, recalculate totals
                if (field === 'qty_new') {
                    const qtyNew = parseFloat(value) || 0;
                    const qtyRemaining = line.qty_ordered - line.qty_received;
                    // Limit qty_new to remaining quantity for existing orders
                    if (receptionMode === 'existing' && qtyNew > qtyRemaining) {
                        updatedLine.qty_new = qtyRemaining;
                    }
                }
                return updatedLine;
            }
            return line;
        }));
    };

    const createReception = async () => {
        // debugger
        try {
            setCreatingReception(true);
            setReceptionSuccess(null);
            setReceptionError(null);

            // Get warehouse ID from ref
            const warehouse = entrepots.find(e => e.ref === entrepot);
            if (!warehouse) {
                throw new Error("Entrepôt non valide");
            }

            const action = receptionMode === 'existing' ? "setreception" : "setnewreception";

            const lines = productLines.map(line => {
                const baseLine = {
                    product_id: line.fk_product,
                    qty: line.qty_new
                };

                // Add line_id for existing orders
                if (receptionMode === 'existing') {
                    return {
                        ...baseLine,
                        line_id: line.fk_commandefournisseurdet || ""
                    };
                }

                return {
                    ...baseLine,
                    price: line.pu_ht,
                    remise_percent: line.remise_percent,
                    tva_tx: line.tva_tx
                };
            });

            const receptionData: any = {
                action,
                supplier_id: selectedSupplierId,
                supplier_ref: orderNumber,
                entity: user.entity,
                warehouse_id: warehouse.id,
                lines
            };

            const response: any = await axios.post<CreateReceptionResponse>(
                "https://api.apapiecesauto.fr/apiV2/",
                receptionData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`
                    }
                }
            );

            const responseData = response;

            if (!responseData.success) {
                throw new Error(responseData.message || "Failed to create reception");
            }

            const receptionId = responseData.reception_id || responseData.data?.reception_id;

            // Commandes client liées aux quantités effectivement reçues (déjà connues côté front,
            // indépendamment de ce que renvoie le backend).
            const linkedCustomerRefs = Array.from(new Set(
                productLines
                    .filter(line => line.customer_order_id && Number(line.qty_new) > 0)
                    .map(line => line.customer_order_ref)
                    .filter((ref): ref is string => !!ref)
            ));
            const hasLinkedCustomerOrder = productLines.some(
                line => line.customer_order_id && Number(line.qty_new) > 0
            );

            if (responseData.commande_ref || hasLinkedCustomerOrder) {
                const displayRef = responseData.commande_ref || linkedCustomerRefs.join(', ');
                setReceptionSuccess({
                    type: 'withNavigation',
                    message: `Réception créée avec succès!${receptionId ? ` ID: ${receptionId}` : ''}${displayRef ? ` La commande ${displayRef} est prête pour expédition.` : ''}`,
                    commande_ref: displayRef,
                    commande_id: responseData.commande_id,
                    entityname: responseData.entityname || ""
                });

                // L'admin se voit proposer (Oui/Non) la génération de l'expédition
                // de la quantité reçue — voir l'alerte de succès ci-dessous.
            } else {
                setReceptionSuccess({
                    type: 'simple',
                    message: 'Réception créée avec succès!'
                });

                setTimeout(() => {
                    setArticlesModalOpen(false);
                    resetReceptionForm();
                    fetchFournisseurOrders();
                }, 2000);
            }
        } catch (err: any) {
            console.error("Error creating reception:", err);
            setReceptionError(err.message || "Erreur lors de la création de la réception");
        } finally {
            setCreatingReception(false);
        }
    };

    // Génère/valide une expédition de la quantité reçue dans la/les commande(s) client liée(s)
    const handleShipReceivedToCustomerOrders = async () => {
        // Regrouper les quantités reçues par commande client
        const ordersToShip = new Map<string, string>(); // id -> ref
        productLines.forEach(line => {
            if (line.customer_order_id && Number(line.qty_new) > 0) {
                ordersToShip.set(String(line.customer_order_id), line.customer_order_ref || "");
            }
        });

        if (ordersToShip.size === 0) {
            setShipResult({ success: false, message: "Aucune commande client liée à la quantité reçue." });
            return;
        }

        setShippingExpedition(true);
        setShipResult(null);

        const messages: string[] = [];
        let hasError = false;

        try {
            for (const [orderId, orderRef] of Array.from(ordersToShip.entries())) {
                const label = orderRef || `#${orderId}`;
                try {
                    // 1. Récupérer (ou créer) le brouillon d'expédition de la commande
                    const getResp: any = await axios.post(
                        "https://api.apapiecesauto.fr/apiV2/",
                        { action: "getexpedition", orderid: Number(orderId), entity: user.entity },
                        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${user.token}` } }
                    );

                    const expeditions = getResp?.data;
                    if (!Array.isArray(expeditions) || expeditions.length === 0) {
                        messages.push(`Commande ${label} : expédition introuvable.`);
                        hasError = true;
                        continue;
                    }

                    const expedition = expeditions[0];

                    // 2. Mapper les lignes d'expédition avec la quantité reçue (par produit)
                    const lines = (expedition.lines || [])
                        .map((exLine: any) => {
                            const received = productLines
                                .filter(pl =>
                                    String(pl.customer_order_id) === orderId &&
                                    String(pl.fk_product) === String(exLine.product_id)
                                )
                                .reduce((sum, pl) => sum + (Number(pl.qty_new) || 0), 0);

                            if (received <= 0) return null;

                            const ordered = Number(exLine.qty) || 0;
                            const already = Number(exLine.alreadyshipped) || 0;
                            const remaining = ordered - already;
                            const qtyShipped = remaining > 0 ? Math.min(received, remaining) : received;

                            return qtyShipped > 0 ? { id: parseInt(exLine.id), qty_shipped: qtyShipped } : null;
                        })
                        .filter((l: any) => l !== null);

                    if (lines.length === 0) {
                        messages.push(`Commande ${label} : aucune ligne correspondante à expédier.`);
                        continue;
                    }

                    // 3. Mettre à jour et valider l'expédition
                    const setResp: any = await axios.post(
                        "https://api.apapiecesauto.fr/apiV2/",
                        { action: "setexpedition", expeditionid: parseInt(expedition.id), entity: user.entity, lines, force_partial: user?.userinfo?.admin === "1" ? 1 : 0 },
                        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${user.token}` } }
                    );

                    if (setResp?.success) {
                        messages.push(`Commande ${label} : ${setResp.message || "expédition générée"}.`);
                    } else {
                        hasError = true;
                        messages.push(`Commande ${label} : ${setResp?.message || "échec de l'expédition"}.`);
                    }
                } catch (err: any) {
                    hasError = true;
                    messages.push(`Commande ${label} : ${err.message || "erreur lors de l'expédition"}.`);
                }
            }

            setShipResult({ success: !hasError, message: messages.join(" ") });
            if (!hasError) {
                toast.success("Expédition générée avec succès !");
            }
        } finally {
            setShippingExpedition(false);
        }
    };

    // Reset reception form
    // Reset reception form
    const resetReceptionForm = () => {
        setSelectedSupplier("");
        setSelectedSupplierId("");
        setOrderNumber("");
        setProductLines([]);
        setProductSearch("");
        setSearchResults([]);
        setSelectedOrder(null);
        setSelectedOrderId('');
        setReceptionMode('new');
        setReceptionSuccess(null); // Reset to null
        setReceptionError(null);
        setShipResult(null);
        setShippingExpedition(false);
        setShipDeclined(false);
        // Reset to default entrepot if available
        if (entrepots.length > 0) {
            setEntrepot(entrepots[0].ref);
        }
    };
    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        fetchFournisseurOrders(true); // Reset page to 1 on new search
    };


    const handlePageChange = (newPage: number) => {
        if (newPage >= 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    // Calculate totals
    const calculateTotals = () => {
        const totals = productLines.reduce((acc, line) => {
            const lineTotalHT = line.pu_ht * line.qty_new * (1 - line.remise_percent / 100);
            const lineTotalTTC = lineTotalHT * (1 + line.tva_tx / 100);
            return {
                totalHT: acc.totalHT + lineTotalHT,
                totalTTC: acc.totalTTC + lineTotalTTC,
                totalQty: acc.totalQty + line.qty_new
            };
        }, { totalHT: 0, totalTTC: 0, totalQty: 0 });
        return totals;
    };

    // Render loading state
    if (loading && ordersToReceive.length === 0) {
        return (
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="text-center py-5">
                                    <Spinner color="primary" />
                                    <p className="mt-3">Chargement des commandes fournisseurs...</p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    // Render error state
    if (error && ordersToReceive.length === 0) {
        return (
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="text-center py-5">
                                    <div className="text-danger">
                                        <i className="ri-error-warning-line fs-1"></i>
                                        <p>{error}</p>
                        
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    const totals = calculateTotals();

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h4 className="card-title mb-0">Commandes Fournisseurs à Réceptionner</h4>
                                    <div className="d-flex align-items-center gap-2">
                                        <Button
                                            color="info"
                                            onClick={() => navigate("/monstock")}
                                        >
                                            <i className="ri-store-2-line align-bottom me-2"></i>
                                            Mon Stock
                                        </Button>
                                        <Button
                                            color="warning"
                                            onClick={() => setStockCorrectionModalOpen(true)}
                                        >
                                            <i className="ri-stock-line align-bottom me-2"></i>
                                            Corriger Stock
                                        </Button>
                                        <Button
                                            color="primary"
                                            onClick={() => {
                                                resetReceptionForm();
                                                setReceptionModalOpen(true);
                                            }}
                                        >
                                            <i className="ri-truck-line align-bottom me-2"></i>
                                            Nouvelle Réception
                                        </Button>
                                    </div>
                                </div>

                                {/* Search Form */}
                                <form onSubmit={handleSearch} className="mb-4">
                                    <Row className="g-3 align-items-end">
                                        <Col md={2}>
                                            <FormGroup className="mb-0">
                                                <Label for="searchProductRef" className="form-label fw-semibold small text-muted mb-1">
                                                    RÉFÉRENCE PRODUIT
                                                </Label>
                                                <InputGroup>
                                                    <InputGroupText className="bg-light border-end-0">
                                                        <i className="ri-barcode-line"></i>
                                                    </InputGroupText>
                                                    <Input
                                                        id="searchProductRef"
                                                        type="text"
                                                        placeholder="RÉFÉRENCE PRODUIT"
                                                        value={searchProductRef}
                                                        onChange={(e) => setSearchProductRef(e.target.value)}
                                                        className="border-start-0"
                                                        style={{ height: "42px" }}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup className="mb-0">
                                                <Label for="searchFournisseur" className="form-label fw-semibold small text-muted mb-1">
                                                    FOURNISSEUR
                                                </Label>
                                                <InputGroup>
                                                    <InputGroupText className="bg-light border-end-0">
                                                        <i className="ri-user-line"></i>
                                                    </InputGroupText>
                                                    <Input
                                                        id="searchFournisseur"
                                                        type="select"
                                                        value={searchFournisseur}
                                                        onChange={(e) => setSearchFournisseur(e.target.value)}
                                                        className="border-start-0"
                                                        style={{ height: "42px" }}
                                                    >
                                                        <option value="">Tous les fournisseurs</option>
                                                        {fournisseurs.map((fournisseur) => (
                                                            <option key={fournisseur.id} value={fournisseur.id}>
                                                                {fournisseur.nom} ({fournisseur.code_fournisseur})
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup className="mb-0">
                                                <Label for="searchdispatched" className="form-label fw-semibold small text-muted mb-1">
                                                    Etat
                                                </Label>
                                                     
                                                    <Input
                                                        id="statuses"
                                                        type="select"
                                                    style={{ height: "42px" }}
                                                    value={searchStatus}
                                                    onChange={(e) => setSearchStatus(e.target.value)}
                                                    >
                                                        <option value="">Toutes</option>
                                                        <option value="0,1,2,3,4">Non receptionnés</option>
                                                        <option value="5">Receptionnés</option>
                                                         
                                                    </Input>
                                             </FormGroup>
                                        </Col>

                                        <Col md={2} className="ms-auto">
                                            <FormGroup className="mb-0">
                                                <Label className="form-label fw-semibold small text-muted mb-1 d-block">
                                                    &nbsp;
                                                </Label>
                                                <div className="d-flex gap-2">
                                        
                                                    <Button
                                                        type="submit"
                                                        color="primary"
                                                        className="w-100"
                                                        style={{ height: "42px" }}
                                                        disabled={loading}
                                                    >
                                                        {loading ? (
                                                            <Spinner size="sm" />
                                                        ) : (
                                                            <>
                                                                <i className="ri-search-line align-bottom me-1"></i>
                                                                Rechercher
                                                            </>
                                                        )}
                                                    </Button>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </form>

                       

                                <div className="table-responsive">
                                    <Table hover className="mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Référence</th>
                                                <th>Réf. Fournisseur</th>
                                                <th>Date Création</th>
                                                <th>Fournisseur</th>
                                                <th>Statut</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading && ordersToReceive.length === 0 ? (
                                                <tr>
                                                    <td colSpan={6} className="text-center py-4">
                                                        <Spinner size="sm" className="me-2" />
                                                        Chargement...
                                                    </td>
                                                </tr>
                                            ) : ordersToReceive.length === 0 ? (
                                                <tr>
                                                    <td colSpan={6} className="text-center text-muted py-4">
                                                        <i className="ri-search-line display-5 mb-2"></i>
                                                        <div>Aucune commande fournisseur trouvée</div>
                                                    </td>
                                                </tr>
                                            ) : (
                                                ordersToReceive.map((order) => (
                                                    <tr key={order.rowid}>
                                                        <td>
                                                            <span className="fw-semibold">{order.ref}</span>
                                                        </td>
                                                        <td>
                                                            <span className="text-muted">{order.ref_supplier || "N/A"}</span>
                                                        </td>
                                                        <td>
                                                            {formatDate(order.date_creation)}
                                                        </td>
                                                        <td>
                                                            <div>{order.name}</div>
                                                            <small className="text-muted">
                                                                Créé par: {order.firstname} {order.lastname}
                                                            </small>
                                                        </td>
                                                        <td>
                                                            <Badge
                                                                color={getStatusColor(order.fk_statut)}
                                                            >
                                                                {getStatusText(order.fk_statut)}
                                                            </Badge>
                                                        </td>
                                                        <td>
                                                            <Button
                                                                color="success"
                                                                size="sm"
                                                                onClick={() => handleReceiveExistingOrder(order)}
                                                                title="Réceptionner cette commande"
                                                            >
                                                                <i className="ri-check-line align-bottom me-1"></i>
                                                                Voir / Réceptionner
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Pagination */}
                                {ordersToReceive.length > 0 && totalPages > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                        <div className="text-muted">
                                            Affichage de {countPerPage} commande(s) sur {totalCount}
                                            {(searchProductRef || searchFournisseur) && (
                                                <Badge color="warning" className="ms-2">
                                                    Filtre actif
                                                </Badge>
                                            )}
                                        </div>
                                        <Pagination className="mb-0">
                                            <PaginationItem disabled={page === 1 || loading}>
                                                <PaginationLink first onClick={() => handlePageChange(1)} />
                                            </PaginationItem>
                                            <PaginationItem disabled={page === 1 || loading}>
                                                <PaginationLink previous onClick={() => handlePageChange(page - 1)} />
                                            </PaginationItem>
                                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                let pageNum;
                                                if (totalPages <= 5) {
                                                    pageNum = i + 1;
                                                } else if (page <= 3) {
                                                    pageNum = i + 1;
                                                } else if (page >= totalPages - 2) {
                                                    pageNum = totalPages - 4 + i;
                                                } else {
                                                    pageNum = page - 2 + i;
                                                }
                                                return (
                                                    <PaginationItem
                                                        key={pageNum}
                                                        active={page === pageNum}
                                                        disabled={loading}
                                                    >
                                                        <PaginationLink onClick={() => handlePageChange(pageNum)}>
                                                            {pageNum}
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                );
                                            })}
                                            <PaginationItem disabled={page === totalPages || loading}>
                                                <PaginationLink next onClick={() => handlePageChange(page + 1)} />
                                            </PaginationItem>
                                            <PaginationItem disabled={page === totalPages || loading}>
                                                <PaginationLink last onClick={() => handlePageChange(totalPages)} />
                                            </PaginationItem>
                                        </Pagination>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted">Page</span>
                                            <Input
                                                type="number"
                                                min="1"
                                                max={totalPages}
                                                value={page}
                                                onChange={(e) => {
                                                    const newPage = parseInt(e.target.value);
                                                    if (!isNaN(newPage) && newPage >= 1 && newPage <= totalPages) {
                                                        handlePageChange(newPage);
                                                    }
                                                }}
                                                style={{ width: '70px' }}
                                                className="text-center"
                                                bsSize="sm"
                                                disabled={loading}
                                            />
                                            <span className="text-muted">sur {totalPages}</span>
                                        </div>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Premier Modal - Sélection de base */}
            <Modal isOpen={receptionModalOpen} toggle={() => setReceptionModalOpen(false)}>
                <ModalHeader toggle={() => setReceptionModalOpen(false)}>
                    Nouvelle Réception
                </ModalHeader>
                <ModalBody>
                    <Row className="g-3">
                        <Col md={12}>
                            <FormGroup>
                                <Label>Fournisseur *</Label>
                                <Input
                                    type="select"
                                    value={selectedSupplierId}
                                    onChange={handleSelectFournisseur}
                                    disabled={loadingFournisseurs}
                                >
                                    <option value="">Sélectionner le fournisseur</option>
                                    {fournisseurs.map((fournisseur) => (
                                        <option key={fournisseur.id} value={fournisseur.id}>
                                            {fournisseur.nom} ({fournisseur.code_fournisseur})
                                        </option>
                                    ))}
                                </Input>
                                {loadingFournisseurs && (
                                    <div className="small text-muted mt-1">
                                        <Spinner size="sm" className="me-1" />
                                        Chargement des fournisseurs...
                                    </div>
                                )}
                                {fournisseursError && (
                                    <div className="text-danger small mt-1">{fournisseursError}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <Label>N° Commande ou Facture fournisseur *</Label>
                                <Input
                                    type="text"
                                    placeholder="Saisir le numéro de commande ou facture"
                                    value={orderNumber}
                                    onChange={(e) => setOrderNumber(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <Label>Entrepôt de Reception</Label>
                                <Input
                                    type="select"
                                    value={entrepot}
                                    onChange={(e) => setEntrepot(e.target.value)}
                                    disabled={loadingFournisseurs}
                                >
                                    <option value="">Sélectionner un entrepôt</option>
                                    {entrepots.map((ent) => (
                                        <option key={ent.id} value={ent.ref}>
                                            {ent.ref}
                                        </option>
                                    ))}
                                </Input>
                                {loadingFournisseurs && (
                                    <div className="small text-muted mt-1">
                                        <Spinner size="sm" className="me-1" />
                                        Chargement des entrepôts...
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setReceptionModalOpen(false)}>
                        Annuler
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleContinue}
                        disabled={!selectedSupplierId || !orderNumber || !entrepot}
                    >
                        Continuer
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Deuxième Modal - Ajout des produits */}
            <Modal isOpen={articlesModalOpen} toggle={() => setArticlesModalOpen(false)} size="xl">
                <ModalHeader toggle={() => setArticlesModalOpen(false)}>
                    {receptionMode === 'existing' ? (
                        `Réception commande ${orderNumber}`
                    ) : (
                        `${orderNumber} - Ajout des articles`
                    )}
                </ModalHeader>
                <ModalBody>
                    {receptionSuccess && receptionSuccess.type === 'simple' && (
                        <Alert color="success" className="mb-3">
                            <i className="ri-check-line me-2"></i>
                            {receptionSuccess.message}
                        </Alert>
                    )}

                    {receptionSuccess && receptionSuccess.type === 'withNavigation' && (
                        <Alert color="info" className="mb-3">
                            <i className="ri-information-line me-2"></i>
                            {receptionSuccess.message}
                            <div className="mt-3">
                                <div className="mb-2">
                                    <strong>Commande:</strong> {receptionSuccess.commande_ref}
                                    <br />
                                </div>

                                {/* Résultat de l'expédition */}
                                {shipResult && (
                                    <div className={`alert ${shipResult.success ? 'alert-success' : 'alert-danger'} mt-2 mb-2`}>
                                        <i className={`me-1 ${shipResult.success ? 'ri-check-line' : 'ri-error-warning-line'}`}></i>
                                        {shipResult.message}
                                    </div>
                                )}

                                <div className="d-flex gap-2">
                                    {/* Admin : expédier directement la commande client (sans passer par CommandesEnAttentes) */}
                                    {user?.userinfo?.admin === "1" && !shipResult?.success && (
                                        <Button
                                            color="success"
                                            disabled={shippingExpedition}
                                            onClick={handleShipReceivedToCustomerOrders}
                                            className="d-flex align-items-center"
                                        >
                                            {shippingExpedition ? (
                                                <>
                                                    <Spinner size="sm" className="me-2" />
                                                    Expédition en cours...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="ri-truck-line me-1"></i>
                                                    Oui, expédier la commande client
                                                </>
                                            )}
                                        </Button>
                                    )}
                                    <Button
                                        color="secondary"
                                        onClick={() => {
                                            setArticlesModalOpen(false);
                                            resetReceptionForm();
                                        }}
                                    >
                                        <i className="ri-close-line me-1"></i>
                                        Fermer
                                    </Button>
                                </div>
                            </div>
                        </Alert>
                    )}

                    {receptionError && (
                        <Alert color="danger" className="mb-3">
                            <i className="ri-error-warning-line me-2"></i>
                            {receptionError}
                        </Alert>
                    )}
                    {/* En-tête de la commande */}
                    <Row className="mb-4">
                        <Col md={6}>
                            <div className="p-3 border rounded">
                                <div className="row">
                                    <div className="col-5">
                                        <strong>Réf. fournisseur :</strong>
                                    </div>
                                    <div className="col-7">
                                        {orderNumber}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-5">
                                        <strong>Fournisseur :</strong>
                                    </div>
                                    <div className="col-7">
                                        {selectedSupplier}
                                    </div>
                                </div>
                                {(() => {
                                    const customerRefs = Array.from(new Set(
                                        productLines
                                            .map(line => line.customer_order_ref)
                                            .filter((ref): ref is string => !!ref)
                                    ));
                                    if (customerRefs.length === 0) return null;
                                    return (
                                        <div className="row mt-2">
                                            <div className="col-5">
                                                <strong>Commande client :</strong>
                                            </div>
                                            <div className="col-7">
                                                {customerRefs.map(ref => (
                                                    <Badge color="info" className="me-1" key={ref}>{ref}</Badge>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })()}
                                {receptionMode === 'existing' && selectedOrder && (
                                    <div className="row mt-2">
                                        <div className="col-5">
                                            <strong>Statut :</strong>
                                        </div>
                                        <div className="col-7">
                                            <Badge color={getStatusColor(selectedOrder.fk_statut)}>
                                                {getStatusText(selectedOrder.fk_statut)}
                                            </Badge>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="p-3 border rounded">
                                <div className="row">
                                    <div className="col-5">
                                        <strong>Date :</strong>
                                    </div>
                                    <div className="col-7">
                                        {new Date().toLocaleDateString('fr-FR')}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-5">
                                        <strong>Entrepôt :</strong>
                                    </div>
                                    <div className="col-7">
                                        {entrepot}
                                    </div>
                                </div>
                                {receptionMode === 'existing' && selectedOrder && (
                                    <div className="row mt-2">
                                        <div className="col-5">
                                            <strong>Date commande :</strong>
                                        </div>
                                        <div className="col-7">
                                            {formatDate(selectedOrder.date_commande)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>

                    {/* Recherche de produit (only for new reception) */}
                    {receptionMode === 'new' && (
                        <Row className="mb-3">
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Recherche produit (3 caractères minimum)</Label>
                                    <InputGroup>
                                        <Input
                                            type="text"
                                            placeholder="Référence ou nom du produit..."
                                            value={productSearch}
                                            onChange={handleProductSearchChange}
                                            minLength={3}
                                        />
                                        <Button color="primary" onClick={() => addProductLine()}>
                                            <i className="ri-add-line align-bottom me-1"></i>
                                            Nouvelle ligne
                                        </Button>
                                    </InputGroup>
                                    {searchingProducts && (
                                        <div className="mt-2">
                                            <Spinner size="sm" className="me-2" />
                                            <span className="text-muted">Recherche en cours...</span>
                                        </div>
                                    )}
                                    {searchError && (
                                        <div className="alert alert-danger mt-2 py-2">
                                            <i className="ri-error-warning-line me-1"></i>
                                            {searchError}
                                        </div>
                                    )}
                                    {productSearch.length >= 3 && searchResults.length > 0 && (
                                        <div className="border rounded mt-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            {searchResults.map((product) => {
                                                const priceData = getPriceData(product);
                                                const hasValidPrice = priceData.fourn_unitprice > 0;
                                                return (
                                                    <div
                                                        key={product.id}
                                                        className="p-2 border-bottom cursor-pointer"
                                                        onClick={() => addProductLine(product)}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <div>
                                                                <div className="fw-semibold text-primary mb-1">
                                                                    {product.ref}
                                                                    <Badge color="light" className="ms-2 text-dark">
                                                                        {product.brand_name}
                                                                    </Badge>
                                                                </div>
                                                                <div className="mb-1 text-muted small">
                                                                    {product.label}
                                                                </div>
                                                                {product.barcode && (
                                                                    <div className="small">
                                                                        Code-barres: {product.barcode}
                                                                    </div>
                                                                )}
                                                                {priceData.fourn_name && (
                                                                    <div className="small text-muted">
                                                                        Fournisseur: {priceData.fourn_name}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                    {productSearch.length >= 3 && searchResults.length === 0 && !searchingProducts && !searchError && (
                                        <div className="border rounded mt-2 p-4 text-center text-muted">
                                            <i className="ri-search-line display-5 mb-2"></i>
                                            <div>Aucun produit trouvé</div>
                                        </div>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                    )}

                    {/* Table des produits */}
                    {(() => {
                        const showCustomerOrderColumn = Array.from(new Set(
                            productLines
                                .map(line => line.customer_order_ref)
                                .filter((ref): ref is string => !!ref)
                        )).length > 1;
                        const baseColSpan = receptionMode === 'existing' ? 6 : 4;
                        const colSpan = showCustomerOrderColumn ? baseColSpan + 1 : baseColSpan;
                        return (
                    <div className="table-responsive">
                        <Table bordered className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Référence</th>
                                    <th>Description</th>
                                    {showCustomerOrderColumn && (
                                        <th>Commande client</th>
                                    )}
                                    {receptionMode === 'existing' && (
                                        <>
                                            <th className="text-center">Qté commandée</th>
                                        </>
                                    )}
                                    <th className="text-center">Qté à recevoir</th>
                                    <th className="text-center">Stock actuel</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {productLines.length === 0 ? (
                                    <tr>
                                        <td colSpan={colSpan} className="text-center text-muted py-4">
                                            {receptionMode === 'existing'
                                                ? "Aucune ligne à recevoir pour cette commande."
                                                : "Aucune ligne ajoutée. Recherchez un produit pour commencer."}
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {productLines.map((line) => {
                                            const qtyRemaining = receptionMode === 'existing'
                                                ? line.qty_ordered - line.qty_received
                                                : line.qty_ordered;

                                            return (
                                                <tr key={line.id}>
                                                    <td>
                                                        <div className="fw-semibold">{line.ref || "N/A"}</div>
                                                        {line.brand_name && (
                                                            <Badge color="primary" className="mt-1">
                                                                {line.brand_name}
                                                            </Badge>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="small">{line.label}</div>
                                                        {line.barcode && (
                                                            <div className="text-muted extra-small">
                                                                Code-barres: {line.barcode}
                                                            </div>
                                                        )}
                                                    </td>
                                                    {showCustomerOrderColumn && (
                                                        <td>
                                                            {line.customer_order_ref
                                                                ? <Badge color="info">{line.customer_order_ref}</Badge>
                                                                : <span className="text-muted">—</span>}
                                                        </td>
                                                    )}
                                                    {receptionMode === 'existing' && (
                                                        <>
                                                            <td className="text-center">
                                                                <div className="fw-semibold">{line.qty_ordered}</div>
                                                            </td>

                                                        </>
                                                    )}
                                                    <td className="text-center">
                                                        <Input
                                                            type="number"
                                                            value={line.qty_new}
                                                            onChange={(e) => updateProductLine(line.id, 'qty_new', e.target.value)}
                                                            min="0"
                                                            max={receptionMode === 'existing' ? qtyRemaining : undefined}
                                                            style={{ width: '100px', margin: '0 auto' }}
                                                            className="text-center"
                                                        />

                                                    </td>
                                                    <td className="text-center">
                                                        <div>{line.stock || 0}</div>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            onClick={() => removeProductLine(line.id)}
                                                        >
                                                            <i className="ri-delete-bin-line"></i>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </>
                                )}
                            </tbody>
                        </Table>
                    </div>
                        );
                    })()}
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        {/*<div className="text-muted">*/}
                        {/*    {productLines.length} ligne(s) {receptionMode === 'existing' ? 'à recevoir' : 'ajoutée(s)'}*/}
                        {/*    {totals.totalQty > 0 && ` | ${totals.totalQty} unité(s) | Total HT: ${totals.totalHT.toFixed(2)} €`}*/}
                        {/*</div>*/}
                        <div className="d-flex gap-2">
                            <Button color="secondary" onClick={() => setArticlesModalOpen(false)}>
                                Annuler
                            </Button>
                            <Button
                                color="success"
                                onClick={createReception}
                                disabled={productLines.length === 0 || creatingReception}
                            >
                                {creatingReception ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Création en cours...
                                    </>
                                ) : (
                                    <>
                                        <i className="ri-check-line align-bottom me-2"></i>
                                        {receptionMode === 'existing' ? 'Valider la réception' : 'Créer la réception'}
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>

            <StockCorrectionModal
                isOpen={stockCorrectionModalOpen}
                toggle={() => setStockCorrectionModalOpen(false)}

            />

        </div>
    );
};

export default Stock;